module.exports = __webpack_public_path__ + "img/apidays-onsite-1.33da077e.jpg";